var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * Archive component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconTextStrikethrough extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="#3F3F3F"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.7122 0.808415C9.65213 0.902423 7.76391 2.08361 6.75982 3.90646C5.83961 5.57697 5.78302 7.6284 6.60965 9.34805C6.90252 9.95731 7.24541 10.4486 7.7288 10.9517L8.02049 11.2553L5.07238 11.2617L2.12424 11.268L2.02702 11.3201C1.89387 11.3914 1.7424 11.548 1.67575 11.6834C1.59636 11.8446 1.59636 12.1555 1.67575 12.3167C1.7424 12.4521 1.89387 12.6087 2.02702 12.68L2.12424 12.732L7.04424 12.744C9.75024 12.7506 14.1944 12.7506 16.9202 12.744L21.8762 12.732L21.9735 12.68C22.1066 12.6087 22.2581 12.4521 22.3247 12.3167C22.4041 12.1555 22.4041 11.8446 22.3247 11.6834C22.2581 11.548 22.1066 11.3914 21.9735 11.3201L21.8762 11.268L16.7282 11.2548C11.0864 11.2403 11.465 11.2503 10.8705 11.0996C9.44444 10.7381 8.25166 9.62414 7.7647 8.199C7.34864 6.98133 7.50682 5.5517 8.17798 4.46405C8.54674 3.86642 9.1182 3.29618 9.69624 2.949C10.989 2.17255 12.5917 2.09945 13.9442 2.75525C14.5329 3.04065 15.1172 3.51062 15.5317 4.03205C15.698 4.24128 15.8712 4.5276 16.0325 4.86005C16.1332 5.06748 16.2303 5.23176 16.2863 5.28938C16.5703 5.58151 17.0694 5.58454 17.3537 5.29584C17.4836 5.16398 17.553 5.00635 17.5641 4.8179C17.5761 4.61498 17.5409 4.50283 17.3364 4.09306C17.0409 3.50057 16.7221 3.06228 16.226 2.56644C15.3235 1.66433 14.2356 1.09505 13.0202 0.888887C12.7716 0.846719 12.01 0.783935 11.9042 0.796895C11.8844 0.799319 11.798 0.804503 11.7122 0.808415ZM16.8554 15.3087C16.4564 15.4466 16.2784 15.7708 16.3587 16.2136C16.5624 17.3362 16.4683 18.2069 16.0453 19.116C15.6928 19.8736 15.0334 20.6127 14.3357 21.0324C12.8212 21.9435 10.9569 21.905 9.51624 20.9331C8.8142 20.4594 8.35083 19.9229 7.96594 19.138C7.78102 18.7609 7.69095 18.651 7.48824 18.5549C7.31403 18.4723 7.05192 18.4675 6.88532 18.5438C6.62446 18.6633 6.45776 18.9005 6.43755 19.1809C6.42305 19.382 6.45773 19.4934 6.66231 19.9035C6.96336 20.507 7.2727 20.9326 7.7743 21.4334C8.29128 21.9496 8.80788 22.318 9.43472 22.6175C10.1581 22.9632 10.827 23.134 11.6481 23.1826C13.0851 23.2676 14.4484 22.8541 15.6221 21.9771C15.9208 21.754 16.5269 21.1479 16.7484 20.851C17.405 19.9706 17.7752 19.068 17.9326 17.964C17.9737 17.675 17.973 16.755 17.9314 16.476C17.8353 15.8329 17.7656 15.6285 17.5878 15.4686C17.3755 15.2778 17.1118 15.2202 16.8554 15.3087Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconTextStrikethrough.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconTextStrikethrough.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconTextStrikethrough.prototype, "size", void 0);
if (customElements.get('cat-icon-text-strikethrough') === undefined) {
    customElements.define('cat-icon-text-strikethrough', BlocksIconTextStrikethrough);
}
